import {
    gameTypes,
    isContestGamesWithSecondaryUgc,
    isUgcGames,
    isPurePrizeGames
} from 'config/promoGameTypes';
import { lotteryInstantTypes } from './promoLotteryTypes';

const lotteryShouldOpenWinnerAfterGet = new Set([lotteryInstantTypes.JOIN_AND_GET]);
// 配獎後，要馬上開獎，不需要看動畫
export function isLotteryShouldOpenWinnerAfterGet(lotteryType) {
    return lotteryShouldOpenWinnerAfterGet.has(lotteryType);
}

const gameShouldOpenWinnerAfterGet = new Set([
    gameTypes.SIGN_FORM,
    gameTypes.INVOICE,
    gameTypes.PURCHASE_REWARD,
    gameTypes.SIGN_UP,
    gameTypes.ORDER_REWARD,
    gameTypes.CART_REWARD
]);
export function isGameShouldOpenWinnerAfterGet(gameType) {
    return gameShouldOpenWinnerAfterGet.has(gameType);
}

// 不顯示再次參加的按鈕 (單純返回參加頁)
const doNotShowBackToJoinPageBtnGames = new Set([
    gameTypes.CHECK_IN,
    gameTypes.PSYCHO_QUIZ,
    gameTypes.QUIZ,
    gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE,
    gameTypes.POINTS_REDEEM,
    gameTypes.MGM_SHARE,
    gameTypes.MULTI_CHALLENGE
]);
export function isDoNotShowBackToJoinPageBtnGames(gameType) {
    return doNotShowBackToJoinPageBtnGames.has(gameType);
}

// 不顯示再次參加的按鈕 (會建立新 Entry)
const doNotShowPlayNewEntryBtnGames = new Set([
    gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE,
    gameTypes.INSTAGRAM,
    gameTypes.POINTS_REDEEM,
    gameTypes.MULTI_CHALLENGE
]);
export function isDoNotShowPlayNewEntryBtnGames(gameType) {
    return doNotShowPlayNewEntryBtnGames.has(gameType);
}

// 參加即結果頁的參加紀錄按鈕會額外寫在其他位置
const doNotShowCheckRecordsBtnGames = new Set([
    gameTypes.CHECK_IN,
    gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE,
    gameTypes.POINTS_REDEEM,
    gameTypes.MGM_SHARE,
    gameTypes.MULTI_CHALLENGE
]);
export function isDoNotShowCheckRecordsBtnGames(gameType) {
    return doNotShowCheckRecordsBtnGames.has(gameType);
}

// 隱藏結果頁面 Share 區塊
const hideEntryResultShareGames = new Set([
    gameTypes.PHOTO_UPLOAD,
    gameTypes.PHOTO_FRAME_COMPOSITE,
    gameTypes.VIDEO_UPLOAD,
    gameTypes.SIGN_UP
]);
export function isShowEntryResultShareButton(gameType) {
    return !isContestGamesWithSecondaryUgc(gameType) && !hideEntryResultShareGames.has(gameType);
}

// 隱藏結果頁面 Entry 清單
const hideEntryResultEntryListGames = new Set([gameTypes.SIGN_UP, gameTypes.MEMORY_MATCH]);
export function isShowEntryResultEntryLists(gameType) {
    return !hideEntryResultEntryListGames.has(gameType);
}

const showResultDownloadBtn = new Set([
    gameTypes.PHOTO_FRAME_COMPOSITE,
    gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE,
    gameTypes.PSYCHO_QUIZ,
    gameTypes.QUIZ
]);
export function isShowResultDownloadBtnGame(gameType) {
    return showResultDownloadBtn.has(gameType);
}

const showUgcResultReuploadBtnGame = new Set([gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE]);
export function isShowUgcResultReuploadBtnGame(gameType) {
    return showUgcResultReuploadBtnGame.has(gameType);
}

// 參加即結果頁
const noResultPageGames = new Set([
    gameTypes.CHECK_IN,
    gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE,
    gameTypes.POINTS_REDEEM,
    gameTypes.MGM_SHARE,
    gameTypes.MULTI_CHALLENGE
]);
export function isNoResultPageGames(gameType) {
    return noResultPageGames.has(gameType);
}

//不需要參加者紀錄
const noNeedJoinGameRecord = new Set([gameTypes.MGM_SHARE]);
export function isNoNeedJoinGameRecord(gameType) {
    return noNeedJoinGameRecord.has(gameType);
}

// 遊戲可多次遊玩會有多筆結果
const multiResultEntriesGames = new Set([
    gameTypes.SIGN_FORM,
    gameTypes.INVOICE,
    gameTypes.PURCHASE_REWARD,
    gameTypes.SURVEY,
    gameTypes.ORDER_REWARD,
    gameTypes.CART_REWARD
]);
export function isMultiResultEntriesGames(gameType) {
    return (
        isUgcGames(gameType) ||
        isPurePrizeGames(gameType) ||
        isContestGamesWithSecondaryUgc(gameType) ||
        multiResultEntriesGames.has(gameType)
    );
}

const canReplayCurrentEntryGames = new Set([gameTypes.MEMORY_MATCH]);
export function isCanReplayCurrentEntryGame(gameType) {
    return canReplayCurrentEntryGames.has(gameType);
}

const ugcShowOriginalImgRatio = new Set([
    gameTypes.PHOTO_FRAME_COMPOSITE,
    gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE
]);
export function isUgcGamesShowOriginalImgRatio(gameType) {
    return ugcShowOriginalImgRatio.has(gameType);
}

// 兌點模組的開獎、配獎不會做在 result header component
const doNotShowOpenWinnerBtnGame = new Set([gameTypes.POINTS_REDEEM]);
export function isCanShowOpenWinnerBtnGame(gameType) {
    return !doNotShowOpenWinnerBtnGame.has(gameType);
}

// 兌點模組的填表按鈕不會做在 result header component
const doNotShowSignUpFormBtnGame = new Set([gameTypes.POINTS_REDEEM, gameTypes.MULTI_CHALLENGE]);
export function isCanShowSignUpFormBtnGame(gameType) {
    return !doNotShowSignUpFormBtnGame.has(gameType);
}

// 跳過 Mask Flow 檢查機制
const hasPassMaskFlowGames = new Set([gameTypes.SIGN_UP, gameTypes.CONTEST_ADMIN_UPLOAD]);
export function isPassMaskFlowGames(gameType) {
    return hasPassMaskFlowGames.has(gameType);
}

const shouldNotEnterPasscodeEachTimeGames = new Set([
    gameTypes.PURCHASE_REWARD,
    gameTypes.ORDER_REWARD,
    gameTypes.CART_REWARD
]);
export function hasShouldNotEnterPasscodeEachTimeGames(gameType) {
    return shouldNotEnterPasscodeEachTimeGames.has(gameType);
}
